import React from 'react';
import SocialIcons from '../common/SocialIcons';
import ShareLink from './ShareLink';
import IconButton from '../common/IconButton';
import useI18n from '../../hooks/useI18n';

interface Prop {
  handleShareModalClose?: () => void;
  link: string;
}

const LinkShareCard: React.FC<Prop> = ({
  handleShareModalClose,
  link = '',
}) => {
  const { t } = useI18n();
  console.log('link from share', link);

  return (
    <div className="px-5">
      <div className="flex justify-between mb-6">
        <span className="font-content text-[#113e53]">{t('links.share')}</span>
        <IconButton
          src="/assets/svgs/fi_cross.svg"
          onClick={handleShareModalClose}
          className="size-50"
        />
      </div>
      <SocialIcons link={link} />
      <ShareLink link={link} />
    </div>
  );
};

export default LinkShareCard;
